<tcc-simplePanel [size]="panalSize" [buttons]="['close']" (buttonClick)="close()">

    <div panel-header *ngIf="state === 'ready'">
        <div *ngIf="addOrEdit === 'add'">Add</div>
        <div *ngIf="addOrEdit === 'edit'">Edit {{currentViewInfo?.viewId}}</div>
    </div>

    <div panel-body *ngIf="state === 'ready'">
        <div class="container">
            <div class="row">
                <div class="col-12" style="text-align: center;">
                    <h4>View Info</h4>
                </div>
            </div>           

            <form [formGroup]="viewInfoFormGroup" (ngSubmit)="onSubmit()">

                <label for="viewId">View Id: </label>
                <input type="number" 
                        [ngClass]="{changed: isChanged('viewId')}"
                        formControlName="viewId"
                        #viewId
                        [readonly]="true" 
                        viewId="viewId" 
                        (input)="fieldChanged(viewId)">  
             
                <label for="Name">Name: </label>
                <input type="text" 
                        [ngClass]="{changed: isChanged('name')}"
                        formControlName="name"
                        #name
                        name="name" 
                        (input)="fieldChanged(name)">  

                        <br />
                        <br />

                <label for="ledgerId">Ledger ID: </label>
                        <select formControlName="ledgerId"
                        [ngClass]="{changed: isChanged('ledgerId')}"
                        name="ledgerId"
                        #ledgerId
                        >
                        <option *ngFor="let ledger of ledgers$ | async" [ngValue]="ledger.ledgerId">
                            {{ ledger.name }}
                        </option>
                </select>                     

                <div style="margin-top: 10px;">
                    <button type="submit" [disabled]="!viewInfoFormGroup.valid || 
                                                      !viewInfoFormGroup.dirty || 
                                                      (duplicateKey && addOrEdit === 'add')">Save</button>
                </div>
            </form>
        </div>
    </div>

</tcc-simplePanel>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>
